import { FC } from 'react';

import { Form, Item, RequiredRule } from 'devextreme-react/form';
import { DropDownOptions } from 'devextreme-react/select-box';

import AppFiledBox from 'components/appComponents/app-field-box';
import { DateBox, NumberBox, SelectBox, TagBox, Validator } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import { ContractorDeliveryPriceCreate } from 'pages/Contractor/ContractorDeliveryPrice.entity';

type Props = {
  form: ContractorDeliveryPriceCreate;
  onChange: (
    name: keyof ContractorDeliveryPriceCreate,
    value: ContractorDeliveryPriceCreate[keyof ContractorDeliveryPriceCreate],
  ) => void;
  factories: DataSource;
  storeObject: DataSource;
  type: 'EDIT' | 'CREATE';
};

export const ContractorDeliveryPriceForm: FC<Props> = ({ form, onChange, factories, storeObject, type }) => {
  return (
    <div>
      <AppFiledBox label="Площадка" labelTop>
        {type === 'CREATE' ? (
          <TagBox
            stylingMode="underlined"
            dataSource={factories}
            displayExpr="name"
            valueExpr="id"
            showSelectionControls={true}
            onValueChanged={(e) => {
              onChange('factoryIds', e.value);
            }}
          >
            <DropDownOptions title="Выберите площадку" closeOnOutsideClick={true} showTitle={false} />
            <Validator>
              <RequiredRule message="Выберите площадку" />
            </Validator>
          </TagBox>
        ) : (
          <SelectBox
            stylingMode="underlined"
            dataSource={factories}
            displayExpr="name"
            valueExpr="id"
            value={form.factoryId}
            onItemClick={(e) => {
              onChange('factoryId', e.itemData.id);
            }}
          >
            <DropDownOptions title="Выберите площадку" closeOnOutsideClick={true} showTitle={false} />
            <Validator>
              <RequiredRule message="Выберите площадку" />
            </Validator>
          </SelectBox>
        )}
      </AppFiledBox>

      <AppFiledBox label="Объект" labelTop>
        <SelectBox
          stylingMode="underlined"
          dataSource={storeObject}
          displayExpr="address"
          valueExpr="id"
          value={form.objectId}
          searchEnabled
          onItemClick={(e) => {
            onChange('objectId', e.itemData.id);
          }}
        >
          <DropDownOptions title="Выберите объект" closeOnOutsideClick={true} showTitle={false} />
        </SelectBox>
      </AppFiledBox>
      <AppFiledBox label="Дата начала" labelTop>
        <DateBox
          stylingMode="underlined"
          type="date"
          onValueChange={(e) => {
            onChange('dateBegin', e as string);
          }}
          useMaskBehavior
          dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
          value={form.dateBegin}
        >
          <Validator>
            <RequiredRule message="Заполните поле дата начала" />
          </Validator>
        </DateBox>
      </AppFiledBox>
      <AppFiledBox label="Объем" labelTop>
        <NumberBox
          stylingMode="underlined"
          value={form.maxQuantity || undefined}
          onValueChange={(e) => {
            onChange('maxQuantity', e);
          }}
        >
          <Validator>
            <RequiredRule message="Заполните поле объем" />
          </Validator>
        </NumberBox>
      </AppFiledBox>
      <AppFiledBox label="Цена" labelTop>
        <NumberBox
          stylingMode="underlined"
          value={form.price || undefined}
          onValueChange={(e) => {
            onChange('price', e);
          }}
        >
          <Validator>
            <RequiredRule message="Заполните поле цена" />
          </Validator>
        </NumberBox>
      </AppFiledBox>
    </div>
  );
};
